export default __webpack_public_path__ + "static/media/workshop-floorplan.d5af9b3d.png";